/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1BadgeIcon24Solid = forwardRef('People1BadgeIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 13a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 14c-2.985 0-8.736.395-9.821 6.01C1.969 21.093 2.895 22 4 22h16c1.105 0 2.03-.906 1.821-1.99C20.736 14.394 14.985 14 12 14Zm0 5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z" })));
});
